import React from 'react';
import { getSnippetRenderDimensions } from './utils';
import { Dimensions, FlexibleContainerDimensions } from './types';
import { MedicalProfileFiles } from '../../../primary-record-types';
import { Image, View } from 'react-native';

export type SnippetDisplayOwnProps = {
    fileUrl: string;
    containerDimensions: FlexibleContainerDimensions;
    pageDimensions: Dimensions;
    boundingBox: MedicalProfileFiles.BoundingBox;
    type: 'pdf-image' | 'image';
    rotation: MedicalProfileFiles.Rotation;
};

export type SnippetDisplayProps = SnippetDisplayOwnProps;

const SnippetDisplay: React.FC<SnippetDisplayProps> = (props) => {
    const snippetRenderDimensions = getSnippetRenderDimensions({
        containerDimensions: props.containerDimensions,
        dimensions: props.pageDimensions,
        rotation: props.rotation,
        fileType: props.type,
        boundingBox: props.boundingBox,
    });

    const renderImage = () => (
        <Image
            source={{ uri: props.fileUrl }}
            alt="Image"
            style={{
                ...snippetRenderDimensions.contentDimensions,
            }}
        />
    );

    return (
        <View
            style={{
                ...snippetRenderDimensions.containerDimensions,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <View
                style={{
                    position: 'absolute',
                    top: -snippetRenderDimensions.offset.top,
                    left: -snippetRenderDimensions.offset.left,
                }}
            >
                {renderImage()}
            </View>
        </View>
    );
};

export default React.memo(SnippetDisplay);
